var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-filters',{attrs:{"options":_vm.options,"mainOptions":_vm.mainOptions,"count":_vm.summary,"selectedFilter":_vm.selectedFilter,"setFilter":_vm.setMainFilter}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-023618e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_dashboard/states/filter/states-filter.vue
// module id = Ztt6
// module chunks = 1